import unblockCancelTripMessagesModule from "./unblockCancelTripMessagesModule"
import server from "../server"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"
import tdnSpecification from "../r2/tdnSpecification.json"

unblockCancelTripMessagesModule.controller("unblockCancelTripMessagesController", [
    "$scope", "$q", "loadingService", "unblockCancelTripMessagesService", "unblockCancelTripMessageDialog", "messagesModal", "remoteExceptionHandler", ($scope, $q, loadingService, unblockCancelTripMessagesService, unblockCancelTripMessageDialog, messagesModal, remoteExceptionHandler) => {

        $scope.tdn = tdnSpecification["unblock-cancel-trip-messages"]

        const paginationApi = $q.defer()
        let filterPatch = []

        $scope.filterServiceUrl = server.getRelativeUrl("search.unblockCancelTripMessages")

        $scope.messageStatusProcessed = "br.com.neolog.model.integration.domain.UnblockTripMessageStatus.PROCESSED"

        $scope.tableOptions = {
            records: [],
            columns: [{
                cell: {
                    template: "<a name='forceProcess' ng-disabled='!isValidToForceProcessMessage(record)' class='btn btn-xs btn-danger' ng-click='forceProcessMessage(record)'><span class='fa fa-times-circle'></span></a>"
                },
                cellName: "forceProcessButton",
                width: "10px"
            },{
                header: "presentationnode.nodeproperty.unblockcanceltripmessage.id",
                cell: "{{record.mappedProperties['presentationnode.unblockcanceltripmessage.id'].value}}",
                cellName: "id"
            },{
                header: "presentationnode.nodeproperty.unblockcanceltripmessage.tripCodes",
                cell: "{{record.mappedProperties['presentationnode.unblockcanceltripmessage.tripCodes'].value}}",
                cellName: "tripCodes"
            },{
                header: "presentationnode.nodeproperty.unblockcanceltripmessage.lastupdate",
                cell: "{{record.mappedProperties['presentationnode.unblockcanceltripmessage.lastupdate'].value | date:'short'}}",
                cellName: "lastupdate"
            },{
                header: "presentationnode.nodeproperty.unblockcanceltripmessage.status",
                cell: "{{record.mappedProperties['presentationnode.unblockcanceltripmessage.status'].value}}",
                cellName: "status"
            },{
                cell: {
                    template: "<a name='inspect' class='btn btn-xs btn-primary' ng-click='inspectMessage(record)'><span class='fa fa-search'></span></a>"
                },
                cellName: "inspectButton",
                width: "10px"
            }],
            pagination: {
                onPaginate: function (firstResult, maxResults) {
                    return loadingService(unblockCancelTripMessagesService.filter(filterPatch, firstResult, maxResults)
                        .then(function (response) {
                            response.result = response.result[0].children
                            mapChildrenProperties(response.result)
                            return response
                        }))
                }
            },
            onRegisterPagination: function (api) {
                paginationApi.resolve(api)
            }
        }

        $scope.isValidToForceProcessMessage = function (record) {
            let status = record.mappedProperties["presentationnode.unblockcanceltripmessage.status"].value
            return $scope.messageStatusProcessed !== status
        }

        $scope.forceProcessMessage = function(record){
            if (!$scope.isValidToForceProcessMessage(record)) {
                return
            }
            messagesModal.cancellable("dialog.proceed?", [{
                keyBundle: "interface.unblockCancelTripMessage.forceProcessMessageWarning",
                parameters: [record.id]
            }]).then(function(){
                return loadingService(unblockCancelTripMessagesService.forceProcessMessage(record.id))
                    .then(function() {
                    return messagesModal("dialog.success", [{
                        keyBundle: "interface.unblockCancelTripMessage.forceProcessMessageSuccess",
                        parameters: []
                    }])
                    .finally(function(){
                        $scope.search( filterPatch )
                    })
                }, remoteExceptionHandler())
            })
        }

        $scope.inspectMessage = (record) => {
            loadingService(unblockCancelTripMessagesService.find(record.id))
                .then(unblockCancelTripMessageDialog)
                .catch(remoteExceptionHandler())
        }

        function mapChildrenProperties(children) {
            arrays.each(children, function (child) {
                var map = {}
                arrays.each(child.properties, function (property) {
                    map[property.messageKey] = property
                })
                child.mappedProperties = map
            })
        }

        $scope.search = function (patch) {
            filterPatch = patch
            return paginationApi.promise.then((api) => api.seekPage(1))
        }
    }])
